// import React from 'react';
// import { Box, Typography, CircularProgress, Alert } from '@mui/material';
// import { gql, useQuery } from '@apollo/client';
// import LlmOverviewCards from './LLMOverviewCards';
// import LlmUsageChart from './LLMUsageChart';
// import RequestTimeChart from './RequestTimeChart';
// import LlmSplitChart from './LLMSplitChart';
// import Summary from './LLMSummary';
// import TracesByTime from './TracesByTime';
// import Traces from './Traces';

// // 1. Define the GraphQL Query
// const GET_LLM_OBSERVABILITY_DATA = gql`
//   query GetLlmObservability($tenantId: ID!) {
//     getLlmObservability(tenantId: $tenantId) {
//       overview {
//         totalTokens { value change monthlyTrend }
//         totalCost { value change monthlyTrend }
//         llmCalls { value change monthlyTrend }
//       }
//       usageTimeSeries {
//         date
//         models
//       }
//       usageSplit {
//         model
//         value
//         percentage
//       }
//       performance {
//         model
//         avgCompletionTimeSeconds
//       }
//       summary {
//         avgTokensPerMessage
//         avgCostPerMessage
//         p90TimeToFirstTokenMs
//         p90CompletionTimeSeconds
//         avgTokensPerMessageChange
//         avgCostPerMessageChange
//         p90TimeToFirstTokenMsChange
//         p90CompletionTimeSecondsChange
//       }
//       totalTraces
//       traceSplit {
//         count
//         name
//       }
//       traceTimeSeries {
//         count
//         date
//       }
//     }
//   }
// `;

// // 2. Define the props for the component
// interface LLMObservabilityProps {
//   tenantId?: string;
// }

// const NoTenantEmptyState: React.FC = () => (
//     <Box
//       sx={{
//         background: '#F9F9F9', 
//         width: '100%',
//         minHeight: 'calc(100vh - 100px)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         p: 2,
//       }}
//     >
//       <Box sx={{
//         backgroundColor: '#FFFFFF',
//         borderRadius: '16px',
//         p: { xs: 4, md: 6 },
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center',
//         maxWidth: '2000px',
//         width: '100%',
//         height:'690px',
//         marginTop:"10px"
//       }}>
//         <img 
//           src="/icons/no-cost-analysis.svg" 
//           alt="No Tenant Selected" 
//           style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
//         />
//         <Typography 
//           variant="h6" 
//           sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
//         >
//             No Tenant Added
//         </Typography>
//         <Typography 
//           variant="body1" 
//           color="text.secondary" 
//           sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter' }}
//         >
//             It looks like you haven't set up a tenant yet. Please add a tenant to begin observibility.
//         </Typography>
//       </Box>
//     </Box>
// );

// const DataFetchErrorState: React.FC = () => (
//     <Box
//       sx={{
//         background: '#F9F9F9', 
//         width: '100%',
//         minHeight: 'calc(100vh - 100px)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         p: 2,
//       }}
//     >
//       <Box sx={{
//         backgroundColor: '#FFFFFF',
//         borderRadius: '16px',
//         p: { xs: 4, md: 6 },
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center',
//         maxWidth: '2000px',
//         width: '100%',
//         height:'690px',
//         marginTop:"10px"
//       }}>
//         <img 
//           src="/icons/unable_to_diplay_data.svg" 
//           alt="Unable to display data" 
//           style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
//         />
//         <Typography 
//           variant="h6" 
//           sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
//         >
//             Unable to Display Data
//         </Typography>
//         <Typography 
//           variant="body1" 
//           color="text.secondary" 
//           sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter',fontSize:'12px' }}
//         >
//             We’re currently experiencing a temporary issue displaying the data. Please try refreshing the page or check back shortly.
//         </Typography>
//       </Box>
//     </Box>
// );

// // --- NEW HELPER COMPONENT ---
// // Renders a centered message for when data has been fetched but is empty.
// const NoDataEmptyState: React.FC<{ title: string; message: string; imgSrc: string }> = ({ title, message, imgSrc }) => (
//   <Box
//       sx={{
//         background: '#F9F9F9', 
//         width: '100%',
//         minHeight: 'calc(100vh - 100px)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         p: 2,
//       }}
//     >
//       <Box sx={{
//         backgroundColor: '#FFFFFF',
//         borderRadius: '16px',
//         p: { xs: 4, md: 6 },
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center',
//         maxWidth: '2000px',
//         width: '100%',
//         height:'690px',
//         marginTop:"10px"
//       }}>
//         <img 
//           src={imgSrc}
//           alt={title}
//           style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
//         />
//         <Typography 
//           variant="h6" 
//           sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
//         >
//             {title}
//         </Typography>
//         <Typography 
//           variant="body1" 
//           color="text.secondary" 
//           sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter',fontSize:'12px' }}
//         >
//             {message}
//         </Typography>
//       </Box>
//     </Box>

//     // <Box sx={{
//     //     display: 'flex',
//     //     flexDirection: 'column',
//     //     alignItems: 'center',
//     //     justifyContent: 'center',
//     //     minHeight: 'calc(100vh - 200px)',
//     //     textAlign: 'center',
//     //     backgroundColor: '#FFFFFF',
//     //     borderRadius: '16px',
//     //     p: 3
//     // }}>
//     //     <img src={imgSrc} alt={title} style={{ width: '150px', height: '150px', marginBottom: '24px' }} />
//     //     <Typography sx={{ fontWeight: 600, fontSize: '16px', mb: 1, fontFamily: 'Inter' }}>{title}</Typography>
//     //     <Typography sx={{ fontFamily: 'Inter', maxWidth: '550px', fontWeight: 400, fontSize: '14px', color: "#666666" }}>
//     //         {message}
//     //     </Typography>
//     // </Box>
// );


// const LLMpage: React.FC<LLMObservabilityProps> = ({ tenantId }) => {
//   const { data, loading, error } = useQuery(GET_LLM_OBSERVABILITY_DATA, {
//     variables: { tenantId },
//     skip: !tenantId, 
//   });

//   if (!tenantId) {
//     return <NoTenantEmptyState />;
//   }

//   if (loading) {
//     return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></Box>;
//   }

//   if (error) {
//     console.error("Error fetching LLM observability data:", error);
//     return <DataFetchErrorState />;
//   }

//   if (!data || !data.getLlmObservability) {
//     return <DataFetchErrorState />;
//   }

//   const llmData = data.getLlmObservability;
//   console.log('llmData',llmData);
//   // --- TEMPORARY MOCK DATA FOR TESTING ---
// const mockSummaryData = {
//   ...llmData.summary, // Use all the real data from the API
//   // Overwrite the change values with test numbers
//   avgTokensPerMessageChange: 50,      // A positive change (bad)
//   avgCostPerMessageChange: -0.001,  // A negative change (good)
//   p90TimeToFirstTokenMsChange: 120,   // A positive change (bad)
//   p90CompletionTimeSecondsChange: 10,  // A zero change (no indicator)
// };
// // ------------------------------------

//   // --- MODIFIED LOGIC ---
//   // If the query is successful but returns no traces, display an empty/processing state.
//   if (llmData.totalTraces === 0) {
//     return (
//       <Box sx={{  bgcolor: '#F9FAFB', }}>
//           <NoDataEmptyState
//               title="No Data found"
//               message="We did not find any data in the LLM data source added."
//               imgSrc="/icons/syncing.svg" // Using a relevant icon from the reference component
//           />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
//       {/* --- Header --- */}
//       <Box sx={{ paddingRight: '24px', flexShrink: 0 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', fontWeight: 600, color:'#333333' }}>LLM Cost and Usage Overview</Typography>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'12px', fontWeight: 400, color:'#666666', mb:2}}> Gain visibility into your LLM spends and token usage.</Typography>
//       </Box>

//       {/* --- Main Content Layout --- */}
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        
//         <LlmOverviewCards overviewData={llmData.overview} isLoading={loading} />

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
//           <Box sx={{ width: '100%', flexGrow: 1, minWidth: 0 }}>
//             <LlmUsageChart usageData={llmData.usageTimeSeries} />
//           </Box>
//           <Box sx={{ width: { xs: '100%', lg: '388px' }, flexShrink: 0 }}>
//             <RequestTimeChart performanceData={llmData.performance} />
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
//           <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
//             <LlmSplitChart splitData={llmData.usageSplit} />
//           </Box>
//           <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
//             <Summary summaryData={llmData.summary} />
//             {/* <Summary summaryData={mockSummaryData} /> */}
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
//             <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
//                 <TracesByTime traceData={llmData.traceTimeSeries} />
//             </Box>
//             <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
//                 <Traces traceSplitData={llmData.traceSplit} totalTraces={llmData.totalTraces} tenantId={tenantId}/>
//             </Box>
//         </Box>

//       </Box>
//     </Box>
//   );
// };

// export default LLMpage;



// import React from 'react';
// import { Box, Typography, CircularProgress, Alert } from '@mui/material';
// import { gql, useQuery } from '@apollo/client';
// import LlmOverviewCards from './LLMOverviewCards';
// import LlmUsageChart from './LLMUsageChart';
// import RequestTimeChart from './RequestTimeChart';
// import LlmSplitChart from './LLMSplitChart';
// import Summary from './LLMSummary';
// import TracesByTime from './TracesByTime';
// import Traces from './Traces';

// // 1. Define the GraphQL Query
// const GET_LLM_OBSERVABILITY_DATA = gql`
//   query GetLlmObservability($tenantId: ID!) {
//     getLlmObservability(tenantId: $tenantId) {
//       overview {
//         totalTokens { value change }
//         totalCost { value change }
//         llmCalls { value change }
//       }
//       usageTimeSeries {
//         date
//         models
//       }
//       usageSplit {
//         model
//         value
//         percentage
//       }
//       performance {
//         model
//         avgCompletionTimeSeconds
//       }
//       summary {
//         avgTokensPerMessage
//         avgCostPerMessage
//         p90TimeToFirstTokenMs
//         p90CompletionTimeSeconds
//       }
//       totalTraces
//       traceSplit {
//         count
//         name
//       }
//       traceTimeSeries {
//         count
//         date
//       }
//     }
//   }
// `;

// // 2. Define the props for the component
// interface LLMObservabilityProps {
//   tenantId?: string;
// }

// // **UPDATED**: The empty state component with a larger, centered box and more spacing.
// const NoTenantEmptyState: React.FC = () => (
//     <Box
//       sx={{
//         background: '#F9F9F9', 
//         width: '100%',
//         minHeight: 'calc(100vh - 100px)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         p: 2,
//       }}
//     >
//       <Box sx={{
//         backgroundColor: '#FFFFFF',
//         borderRadius: '16px',
//         p: { xs: 4, md: 6 },
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center',
//         maxWidth: '2000px',
//         width: '100%',
//         height:'690px',
//         marginTop:"10px"
//       }}>
//         <img 
//           src="/icons/no-cost-analysis.svg" 
//           alt="No Tenant Selected" 
//           style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
//         />
//         <Typography 
//           variant="h6" 
//           sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
//         >
//             No Tenant Added
//         </Typography>
//         <Typography 
//           variant="body1" 
//           color="text.secondary" 
//           sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter' }}
//         >
//             It looks like you haven't set up a tenant yet. Please add a tenant to begin observibility.
//         </Typography>
//       </Box>
//     </Box>
// );

// const DataFetchErrorState: React.FC = () => (
//     <Box
//       sx={{
//         background: '#F9F9F9', 
//         width: '100%',
//         minHeight: 'calc(100vh - 100px)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         p: 2,
//       }}
//     >
//       <Box sx={{
//         backgroundColor: '#FFFFFF',
//         borderRadius: '16px',
//         p: { xs: 4, md: 6 },
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center',
//         maxWidth: '2000px',
//         width: '100%',
//         height:'690px',
//         marginTop:"10px"
//       }}>
//         <img 
//           src="/icons/unable_to_diplay_data.svg" 
//           alt="Unable to display data" 
//           style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
//         />
//         <Typography 
//           variant="h6" 
//           sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
//         >
//             Unable to Display Data
//         </Typography>
//         <Typography 
//           variant="body1" 
//           color="text.secondary" 
//           sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter',fontSize:'12px' }}
//         >
//             We’re currently experiencing a temporary issue displaying the data. Please try refreshing the page or check back shortly.
//         </Typography>
//       </Box>
//     </Box>
// );

// const LLMpage: React.FC<LLMObservabilityProps> = ({ tenantId }) => {
//   // 3. Execute the query
//   const { data, loading, error } = useQuery(GET_LLM_OBSERVABILITY_DATA, {
//     variables: { tenantId },
//     skip: !tenantId, 
//   });

//   if (!tenantId) {
//     return <NoTenantEmptyState />;
//   }

//   // 4. Handle loading and error states for an active query
//   if (loading) {
//     return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></Box>;
//   }

//   if (error) {
//     console.error("Error fetching LLM observability data:", error);
//     return <DataFetchErrorState />;
//   }
//     if (!data || !data.getLlmObservability) {
//     return <DataFetchErrorState />;
//   }

//   // 5. Extract the data to pass to children
//   const llmData = data.getLlmObservability;

//   return (
//     <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
//       {/* --- Header --- */}
//       <Box sx={{ paddingRight: '24px', flexShrink: 0 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', fontWeight: 600, color:'#333333' }}>LLM Cost and Usage Overview</Typography>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'12px', fontWeight: 400, color:'#666666', mb:2}}> Gain visibility into your LLM spends and token usage.</Typography>
//       </Box>

//       {/* --- Main Content Layout --- */}
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        
//         {/* Pass the 'overview' data to the cards */}
//         <LlmOverviewCards overviewData={llmData.overview} isLoading={loading} />

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
//           <Box sx={{ width: '100%', flexGrow: 1, minWidth: 0 }}>
//             {/* Pass 'usageTimeSeries' data */}
//             <LlmUsageChart usageData={llmData.usageTimeSeries} />
//           </Box>
//           <Box sx={{ width: { xs: '100%', lg: '388px' }, flexShrink: 0 }}>
//             {/* Pass 'performance' data */}
//             <RequestTimeChart performanceData={llmData.performance} />
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
//           <Box sx={{ width: '100%', flexBasis: { lg: '50%' } }}>
//             {/* Pass 'usageSplit' data */}
//             <LlmSplitChart splitData={llmData.usageSplit} />
//           </Box>
//           <Box sx={{ width: '100%', flexBasis: { lg: '50%' } }}>
//             {/* Pass 'summary' data */}
//             <Summary summaryData={llmData.summary} />
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
//             <Box sx={{ width: '100%', flexBasis: { lg: '50%' } }}>
//                 {/* Pass 'traceTimeSeries' data */}
//                 <TracesByTime traceData={llmData.traceTimeSeries} />
//             </Box>
//             <Box sx={{ width: '100%', flexBasis: { lg: '50%' } }}>
//                 {/* Pass 'traceSplit' and 'totalTraces' data */}
//                 <Traces traceSplitData={llmData.traceSplit} totalTraces={llmData.totalTraces} tenantId={tenantId}/>
//             </Box>
//         </Box>

//       </Box>
//     </Box>
//   );
// };

// export default LLMpage;



import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import { gql, useQuery, useMutation, useLazyQuery } from '@apollo/client';
import LlmOverviewCards from './LLMOverviewCards';
import LlmUsageChart from './LLMUsageChart';
import RequestTimeChart from './RequestTimeChart';
import LlmSplitChart from './LLMSplitChart';
import Summary from './LLMSummary';
import TracesByTime from './TracesByTime';
import Traces from './Traces';
import RefreshIcon from '@mui/icons-material/Refresh';

// =================================================================
// 1. DEFINE ALL NECESSARY GRAPHQL OPERATIONS
// =================================================================

const GET_LLM_OBSERVABILITY_DATA = gql`
  query GetLlmObservability($tenantId: ID!) {
    getLlmObservability(tenantId: $tenantId) {
      overview {
        totalTokens { value change monthlyTrend }
        totalCost { value change monthlyTrend }
        llmCalls { value change monthlyTrend }
      }
      usageTimeSeries { date models }
      usageSplit { model value percentage }
      performance { model avgCompletionTimeSeconds }
      summary {
        avgTokensPerMessage
        avgCostPerMessage
        p90TimeToFirstTokenMs
        p90CompletionTimeSeconds
        avgTokensPerMessageChange
        avgCostPerMessageChange
        p90TimeToFirstTokenMsChange
        p90CompletionTimeSecondsChange
      }
      totalTraces
      traceSplit { count name }
      traceTimeSeries { count date }
    }
    llmDataSources: llmDataSourcesByTenant(tenantId: $tenantId) {
        id
    }
  }
`;

const REFRESH_LLM_DATA_MUTATION = gql`
  mutation RefreshLlmData($tenantId: ID!, $llmDataSourceIds: [ID!]) {
    refreshLlmDataSources(
      tenantId: $tenantId,
      llmDataSourceIds: $llmDataSourceIds
    )
  }
`;

const GET_LLM_SYNC_STATUS_QUERY = gql`
  query GetLlmSyncStatus($tenantId: ID!, $llmDataSourceIds: [ID!]) {
    getLlmDataSourcesSyncStatus(
      tenantId: $tenantId
      llmDataSourceIds: $llmDataSourceIds
    ) {
      id
      status
    }
  }
`;

// =================================================================
// 2. DEFINE THE PROPS AND EMPTY STATE COMPONENTS
// =================================================================

interface LLMObservabilityProps {
  tenantId?: string;
}

const NoTenantEmptyState: React.FC = () => (
    <Box
      sx={{
        background: '#F9F9F9', 
        width: '100%',
        minHeight: 'calc(100vh - 100px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Box sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        p: { xs: 4, md: 6 },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '2000px',
        width: '100%',
        height:'690px',
        marginTop:"10px"
      }}>
        <img 
          src="/icons/no-cost-analysis.svg" 
          alt="No Tenant Selected" 
          style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
        />
        <Typography 
          variant="h6" 
          sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
        >
            No Tenant Added
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter' }}
        >
            It looks like you haven't set up a tenant yet. Please add a tenant to begin observibility.
        </Typography>
      </Box>
    </Box>
);

const DataFetchErrorState: React.FC = () => (
    <Box
      sx={{
        background: '#F9F9F9', 
        width: '100%',
        minHeight: 'calc(100vh - 100px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Box sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        p: { xs: 4, md: 6 },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '2000px',
        width: '100%',
        height:'690px',
        marginTop:"10px"
      }}>
        <img 
          src="/icons/unable_to_diplay_data.svg" 
          alt="Unable to display data" 
          style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
        />
        <Typography 
          variant="h6" 
          sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
        >
            Unable to Display Data
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter',fontSize:'12px' }}
        >
            We’re currently experiencing a temporary issue displaying the data. Please try refreshing the page or check back shortly.
        </Typography>
      </Box>
    </Box>
);

const NoDataEmptyState: React.FC<{ title: string; message: string; imgSrc: string }> = ({ title, message, imgSrc }) => (
  <Box
      sx={{
        background: '#F9F9F9', 
        width: '100%',
        minHeight: 'calc(100vh - 200px)', 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Box sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        p: { xs: 4, md: 6 },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '2000px',
        width: '100%',
        height:'690px',
        marginTop:"10px"
      }}>
        <img 
          src={imgSrc}
          alt={title}
          style={{ width: '143px', height: '143px', marginBottom: '10px' }} 
        />
        <Typography 
          variant="h6" 
          sx={{ fontWeight: 600, mb: 1, fontFamily:'Inter' }}
        >
            {title}
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ mb: 1, maxWidth: '400px', fontFamily:'Inter',fontSize:'12px' }}
        >
            {message}
        </Typography>
      </Box>
    </Box>
);


// =================================================================
// 3. THE MAIN COMPONENT LOGIC
// =================================================================

const LLMpage: React.FC<LLMObservabilityProps> = ({ tenantId }) => {
  // --- STATE MANAGEMENT ---
  const [isSyncing, setIsSyncing] = useState(false);
  // **FIX #2a**: New state to hold status data, allowing us to reset it.
  const [currentSyncStatus, setCurrentSyncStatus] = useState<any>(null);

  // --- GRAPHQL HOOKS ---
  const { data, loading, error, refetch: refetchAllData } = useQuery(GET_LLM_OBSERVABILITY_DATA, {
    variables: { tenantId },
    skip: !tenantId,
    notifyOnNetworkStatusChange: true,
  });
  
  const [triggerRefresh] = useMutation(REFRESH_LLM_DATA_MUTATION);

  const [pollForStatus, { stopPolling, data: syncStatusData }] = useLazyQuery(GET_LLM_SYNC_STATUS_QUERY, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  // **FIX #2b**: This effect updates our controllable state when new poll data arrives.
  useEffect(() => {
    if (syncStatusData) {
      setCurrentSyncStatus(syncStatusData);
    }
  }, [syncStatusData]);
  
  // **FIX #2d**: This effect now uses our reset-able state (`currentSyncStatus`).
  useEffect(() => {
    if (!isSyncing || !currentSyncStatus || !currentSyncStatus.getLlmDataSourcesSyncStatus) {
      return;
    }

    const statuses = currentSyncStatus.getLlmDataSourcesSyncStatus;
    const stillInProgress = statuses.some(
      (ds: any) => ds.status === 'PENDING' || ds.status === 'RUNNING'
    );

    if (!stillInProgress) {
      console.log("Sync process finished. Stopping polling.");
      stopPolling();
      setIsSyncing(false);
      refetchAllData();

      const hasFailedJobs = statuses.some((ds: any) => ds.status === 'FAILED');
      if (hasFailedJobs) {
        console.error("One or more sync jobs failed.");
      }
    }
  }, [currentSyncStatus, isSyncing, stopPolling, refetchAllData]);

  useEffect(() => {
    return () => {
      stopPolling();
    };
  }, [stopPolling]);


  // --- EVENT HANDLER ---
  const handleRefreshClick = async () => {
    if (!tenantId || !data?.llmDataSources) return;
    
    // **FIX #2c**: Reset the status data at the beginning of every click.
    setCurrentSyncStatus(null);
    console.log("Refresh button clicked. Starting sync process...");
    setIsSyncing(true);

    try {
      const allDataSourceIds = data.llmDataSources.map((ds: any) => ds.id);
      if (allDataSourceIds.length === 0) {
        console.warn("No data sources to refresh.");
        setIsSyncing(false);
        return;
      }

      await triggerRefresh({ 
        variables: { 
          tenantId, 
          llmDataSourceIds: allDataSourceIds 
        } 
      });

      pollForStatus({
        variables: { tenantId, llmDataSourceIds: allDataSourceIds },
        pollInterval: 7000,
      });

    } catch (err)      {
      console.error("Failed to trigger refresh:", err);
      setIsSyncing(false);
    }
  };

  // --- RENDER LOGIC ---
  if (!tenantId) {
    return <NoTenantEmptyState />;
  }
  // Show full-page spinner only on initial load
  if (loading && !data) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></Box>;
  }
  if (error) {
    console.error("Error fetching LLM observability data:", error);
    return <DataFetchErrorState />;
  }
  if (!data || !data.getLlmObservability) {
    return <DataFetchErrorState />;
  }

  const llmData = data.getLlmObservability;

  const HeaderWithRefresh = () => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Box>
        <Typography sx={{ fontFamily:'Inter', fontSize:'14px', fontWeight: 600, color:'#333333' }}>LLM Cost and Usage Overview</Typography>
        <Typography sx={{ fontFamily:'Inter', fontSize:'12px', fontWeight: 400, color:'#666666'}}> Gain visibility into your LLM spends and token usage.</Typography>
      </Box>
      <Button
        variant="outlined"
        onClick={handleRefreshClick}
        disabled={isSyncing}
        startIcon={isSyncing ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}
        sx={{ textTransform: 'none', borderRadius: '8px', height: '36px' }}
      >
        {isSyncing ? 'Syncing...' : 'Refresh Data'}
      </Button>
    </Box>
  );

  if (llmData.totalTraces === 0) {
    return (
      <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
          <HeaderWithRefresh />
          <NoDataEmptyState
              title="No Data found"
              message="We did not find any data in the LLM data source added. Click 'Refresh Data' to perform the initial sync."
              imgSrc="/icons/syncing.svg"
          />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      <HeaderWithRefresh />
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* **FIX #1**: Prevent skeletons on refetch by checking if data already exists. */}
        <LlmOverviewCards overviewData={llmData.overview} isLoading={loading && !data} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
          <Box sx={{ width: '100%', flexGrow: 1, minWidth: 0 }}>
            <LlmUsageChart usageData={llmData.usageTimeSeries} />
          </Box>
          <Box sx={{ width: { xs: '100%', lg: '388px' }, flexShrink: 0 }}>
            <RequestTimeChart performanceData={llmData.performance} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
          <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
            <LlmSplitChart splitData={llmData.usageSplit} />
          </Box>
          <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
            <Summary summaryData={llmData.summary} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3 }}>
            <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
                <TracesByTime traceData={llmData.traceTimeSeries} />
            </Box>
            <Box sx={{ width: '100%', flexBasis: { lg: '50%' }, minWidth: 0 }}>
                <Traces traceSplitData={llmData.traceSplit} totalTraces={llmData.totalTraces} tenantId={tenantId}/>
            </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LLMpage;